import { Component, Input, Output, EventEmitter, HostListener, ChangeDetectorRef } from '@angular/core';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-trace-node',
  templateUrl: './trace-node.component.html',
  styleUrls: ['./trace-node.component.scss']
})
export class TraceNodeComponent {

  showNodes: boolean = false;
  showChildren: boolean = false;

  showMenu: boolean[] = [];

  titleTooltip: string = '';

  @Input() nodes: ITraceNode[];
  @Input() showMenuOption: any[] = [];
  @Input() nameParent: string = '';
  @Output() emitNodes = new EventEmitter<any>();
  @Output() emitShowMenuOption = new EventEmitter<any[]>();

  constructor(private _i18nService: I18nService) {
  }

  ngOnChanges() {
    if (this.nodes) {
      this.showNodes = this.nodes.length > 0;
      if (this.nodes.length > 0) {
        this.nodes.forEach(node => {
          if (!node.DisplayName.includes('TRACE_CONFIGURATION')) {
            node.DisplayName = `TRACE_CONFIGURATION.${node.DisplayName.toUpperCase()}`;
          } else {
            node.DisplayName = node.DisplayName.toUpperCase();
          }
        });
      }
    }
  }

  viewChildren(nodeInput: ITraceNode) {
    const foundNode = this.nodes.find(node => node.DataKeyString === nodeInput.DataKeyString);
    if (foundNode) {
      foundNode.Selected = !foundNode.Selected;
    }
    this.closeAllDropdown();
  }

  clickOnDropdown(event, node) {
    for (let index = 0; index < this.showMenuOption.length; index++) {
      if (this.showMenuOption[index].DataKeyString === node.DataKeyString) {
        this.showMenuOption[index].value = !this.showMenuOption[index].value;
        this.showMenuOption[index].clickY = event.screenY;
      } else {
        this.showMenuOption[index].value = false;
      }
    }
    this.emitShowMenuOption.emit(this.showMenuOption);
  }

  closeAllDropdown() {
    for (let index = 0; index < this.showMenuOption.length; index++) {
      this.showMenuOption[index].value = false;
    }
    this.emitShowMenuOption.emit(this.showMenuOption);
  }

  showDropdown(node) {
    let valueDropdown = false;
    for (let index = 0; index < this.showMenuOption.length; index++) {
      if (this.showMenuOption[index].DataKeyString === node.DataKeyString) {
        valueDropdown = this.showMenuOption[index].value;
        break;
      }
    }
    return valueDropdown;
  }

  setLevel(state, index, node) {
    for (let index = 0; index < this.showMenuOption.length; index++) {
      if (this.showMenuOption[index].DataKeyString === node.DataKeyString) {
        this.showMenuOption[index].value = false;
        break;
      }
    }
    this.findNode(this.nodes, node, state);
    let objectNodes = { nodes: this.nodes, nameParent: this.nameParent };
    this.emitNodes.emit(objectNodes);
  }

  findNode(originalNodes, newNode, state) {
    originalNodes.forEach(node => {
      if (node.DataKeyString === newNode.DataKeyString) {
        newNode.Level = state;
        node.Level = state;
        if (node.Nodes)
          this.setLevelChildren(state, node.Nodes);

      } else {
        if (node.Nodes)
          this.findNode(node.Nodes, newNode, state);
      }
    });
  }

  setLevelChildren(state, nodes) {
    nodes.forEach(node => {
      node.Level = state;
      if (node.Nodes)
        this.setLevelChildren(state, node.Nodes);
    });
  }

  getTitle(node) {
    switch (node.Level) {
      case 'Off':
        return this._i18nService.instant('TRACE_CONFIGURATION.NONE');
      case 'Warning':
        return this._i18nService.instant('TRACE_CONFIGURATION.WARNING');
      case 'Error':
        return this._i18nService.instant('TRACE_CONFIGURATION.ERROR');
      default:
        return this._i18nService.instant('TRACE_CONFIGURATION.INFO');
    }
  }

  isMenuAbove(node): boolean {
    const nodeHeight = 40;
    const menuHeight = 100;
    const windowHeight = window.innerHeight;
    let nodePosition = 0;
    for (let index = 0; index < this.showMenuOption.length; index++) {
      if (this.showMenuOption[index].DataKeyString === node.DataKeyString) {
        nodePosition = this.showMenuOption[index].clickY;
        break;
      }
    }
    return nodePosition > windowHeight - nodePosition - nodeHeight - menuHeight;
  }

  getNodes(data) {
    this.emitNodes.emit(data);
  }

  getShowMenuOption(showMenuOption) {
    this.emitShowMenuOption.emit(showMenuOption);
  }
}


